/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { MenuItem, ListItemText, OutlinedInput } from '@mui/material';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import { Row, Col, Form } from 'react-bootstrap';
import TextInput from 'components/input/textInput';
import { CssSelect } from 'components/helper/helperInut';
import SelectInput from 'components/input/SelectInput';
import { optionValues } from 'components/helper/helper';
import SuggestCourse from 'screen/course/SuggestCourse';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogTitle from '@mui/material/DialogTitle';
// import { checkEnableParseJSON } from 'components/helper/helper';
// import { useAppSelector } from 'app/hooks';
import {
  subjectAreaOptions,
  subjectOptions,
} from 'screen/course/courseConstant';

export const A_F_Grade = [
  { value: 'A+' },
  { value: 'A'  },
  { value: 'A-' },
  { value: 'B+' },
  { value: 'B'  },
  { value: 'B-' },
  { value: 'C+' },
  { value: 'C'  },
  { value: 'C-' },
  { value: 'D+' },
  { value: 'D'  },
  { value: 'D-' },
  { value: 'F'  },
];

export const genGradeOptions = (gradingScale:string) => {
  console.log('genGradeOptions:', gradingScale);
  switch (gradingScale) {
    case 'A-F':
      return A_F_Grade;
    case '1-100':
      return [...optionValues(Array.from({ length: 100 }, (_, i) => i + 1))];
    case '0.0-4.0':
      return [ ...optionValues(Array.from({ length: 41 }, (_, i) => i / 10))];
    case '0.0-5.0':
      return [ ...optionValues(Array.from({ length: 51 }, (_, i) => i / 10))];
    case '1-7':
      return [...optionValues(Array.from({ length: 7 }, (_, i) => i + 1))];
    case '1-10':
      return [...optionValues(Array.from({ length: 10 }, (_, i) => i + 1))];
    case '1-11':
      return [ ...optionValues(Array.from({ length: 11 }, (_, i) => i + 1))];
    case '1-20':
      return [...optionValues(Array.from({ length: 20 }, (_, i) => i + 1))];
    default:
      return [];
  }
}

export const genTermOptions = (schedule: string, gradeNo:number) => {
  let termOptions:any[] = [];
  if (gradeNo===13) { 
    termOptions = [
      { name: 'Final', value: 'Final'},
    ];
    return termOptions;    
  }

  termOptions= [
    { name: 'Final', value: 'Final'},
    { name: 'Semester 1', value: 'Semester 1'},
    { name: 'Semester 2', value: 'Semester 2'},
    { name: 'Semester 3', value: 'Semester 3'},
    { name: 'Semester 4', value: 'Semester 4'},
  ];
  switch(schedule) {
    case 'Semester':
      termOptions = [
        { name: 'Final', value: 'Final'},
        { name: 'Semester 1', value: 'Semester 1'},
        { name: 'Semester 2', value: 'Semester 2'},
      ];
      break;
    case 'Trimester':
      termOptions = [
        { name: 'Final', value: 'Final'},
        { name: 'Semester 1', value: 'Semester 1'},
        { name: 'Semester 2', value: 'Semester 2'},
        { name: 'Semester 3', value: 'Semester 3'},
      ];
      break;
    case 'Quarters':
       termOptions = [
        { name: 'Final', value: 'Final'},
        { name: 'Semester 1', value: 'Semester 1'},
        { name: 'Semester 2', value: 'Semester 2'},
        { name: 'Semester 3', value: 'Semester 3'},
        { name: 'Semester 4', value: 'Semester 4'},
      ];
      break;
    case 'Yearly':
    case 'Other':      
    default:
        termOptions = [
          { name: 'Final', value: 'Final'},
        ];
      break;
  }
  return termOptions;
}


type Props = {
  gradeNo: number;
  open: boolean;
  options: any[];
  handleSave: (values: any) => void;
  onClose: () => void;
};

const FormCreateGpaForecastModal = ({ gradeNo, options, open, handleSave, onClose }: Props) => {
  const schedule = `${(options && options.length>0) ? options[0].schedule : ''}`
  const gradingScale= `${(options && options.length>0) ? options[0].grading_scale : ''}`;
  console.log('FormCreateGpaForecastModal - options:',options);
  console.log('gradingScale:', gradingScale);
  let schoolYears:any[] = []
  if (options && options.length>0) {
    schoolYears.push(options[0].school_year);   
  }
 
  const [searchKey, setSearchKey] = React.useState('');
  const [yearOptions, setYearOptions] =  React.useState<any[]>(schoolYears);
  const [termOptions, setTermOptions] = React.useState<any[]>(genTermOptions(schedule, gradeNo));
  const [gradeOptions, setGradeOptions] = React.useState<any[]>(genGradeOptions(gradingScale));
  const [school, setSchool] = React.useState<any>( (options && options.length>0) ? options[0]: null);
  const formik = useFormik({
    initialValues: {
      gpa_forecast_id: (options && options.length>0) ? options[0].gpa_forecast_id : undefined,
      school_name: (options && options.length>0) ? options[0].school_name: '',
      grading_scale: (options && options.length>0) ? options[0].grading_scale: '',
      schedule: (options && options.length>0) ? options[0].schedule: '',
      school_year: (options && options.length>0 && options[0]?.school_year && options[0]?.school_year.length>0) ? options[0]?.school_year[0] : '',
      school_code: (options && options.length>0) ? options[0]?.school_code : '',
      course: '',
      term: (termOptions && termOptions.length>0) ? termOptions[0].value : 'Final',
      grade: (gradeOptions && gradeOptions.length>0) ? gradeOptions[0].value : '',
      credit: 1,
      is_weight_point: false,
      unweighted_point: '',
      weighted_point: '',
      subject_area: '',
      discipline: '',
    },
    onSubmit: (values) => {
      handleSave(values);
    },
  });

 const highschoolData = options && options.length>0 ? options[0]?.highschoolData || null: null; 
 const [disciplineOptions, setDisciplineOptions] = React.useState<any>(subjectOptions);

  const getDisciplineByType = (type: any) => {
    try {
      let list = disciplineOptions.filter((o: any) => {
        return o.type === type;
      });

      if (list.length > 0) {
        list.push({ value: 'Other', type: '' });
        return list;
      }
    } catch (ex) {
      // skip
    }
    return subjectOptions;
  };

  React.useEffect(() => {
    !open && formik.resetForm();
  }, [open]);

  return (
    <React.Fragment>
      {open && (
      <div className="custom-accordion">
        <div className="custom-accordion-item">
          <h2 className="custom-accordion-header">
            New GPA Forecast Information
          </h2>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>

          <div className="custom-accordion-body">
            <div className="pt-2">
              <Row className="pb-2">
                <Form.Group
                    name="gpa_forecast_id"
                    as={Col}
                    md={6}
                    className="ps-1 pe-2 py-2"
                >
                <Form.Label className={`select-label label-14px`}>School Name</Form.Label>
                  <div style={{ backgroundColor: 'white', borderRadius: '0.5rem'}}>
                    <CssSelect
                      name = "select_school"
                      value={school}
                      onChange={(e:any) => {
                          let obj:any = e.target.value;
                          if (obj) {
                            formik.setFieldValue('gpa_forecast_id', obj.gpa_forecast_id);
                            formik.setFieldValue('school_name', obj.school_name);
                            formik.setFieldValue('schedule', obj.schedule);
                            formik.setFieldValue('school_code', obj.school_code);
                            setTermOptions(genTermOptions(obj.schedule, gradeNo));
                            setGradeOptions(genGradeOptions(obj.grading_scale));
                            setYearOptions(obj.school_year);
                            formik.setFieldValue('school_year', obj.school_year && obj.school_year.length>0 ? obj.school_year[0]:'');
                          }
                          setSchool(obj);
                      }}
                      input={<OutlinedInput label="Tag" />}
                      renderValue={(o:any)=> o.school_name}
                      >
                      {options && options.length>0 && options.map((e) => (
                        <MenuItem key={e.gpa_forecast_id} value={e}>
                          <ListItemText primary={e.school_name} />
                        </MenuItem>
                      ))}
                    </CssSelect>
                  </div>
                </Form.Group>
                <SelectInput
                  id={`schoolYear`}
                  form={formik}
                  option={yearOptions}
                  mdCol="4"
                  label="School Year*"
                  values={formik.values.school_year}
                  name="schoolYear"
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
                <TextInput
                  id={`courseName`}
                  mdCol="12"
                  label="Course Name*"
                  countText={100}
                  name="course"
                  values={formik.values.course}
                  onChange={(e) => {
                    setSearchKey(e.target.value);
                    formik.handleChange(e);
                  }}
                />
                {searchKey?.length > 0 ? (
                  <SuggestCourse
                    searchKey={searchKey}
                    schoolYear={formik.values.school_year}
                    currentHighschool={highschoolData}
                    onUpdateCourseTitle={(course:any) => {
                      if (course) {
                        formik.setFieldValue('subject_area', course.subject_area);
                        formik.setFieldValue('discipline', course.discipline);
                        formik.setFieldValue('course', course.course_title);
                      }
                    }}
                  />
                ) : null}

              <SelectInput
                form={formik}
                option={subjectAreaOptions}
                label="A-G Subject Area"
                values={formik.values.subject_area}
                name={'AGSubjectArea'}
                onChange={formik.handleChange}
                readOnly={true}
              />
              <SelectInput
                form={formik}
                option={getDisciplineByType(formik.values.subject_area)}
                label="Subject/Discipline"
                values={formik.values.discipline}
                name={`discipline`}
                onChange={formik.handleChange}
                readOnly={true}
              />
              </Row>

              <Row className="py-2">
                <TextInput
                  mdCol={3}
                  label="Schedule"
                  values={formik.values.schedule}
                  name="schedule"
                  onChange={formik.handleChange}
                  readOnly={true}
                />
                <TextInput
                  mdCol={3}
                  label="Grading Scale"
                  values={formik.values.grading_scale}
                  name="grading_scale"
                  onChange={formik.handleChange}
                  readOnly={true}
                />
                <SelectInput 
                  mdCol={3}
                  option={termOptions}
                  label="Term"
                  values={formik.values.term}
                  name="term"
                  onChange={formik.handleChange}
                />
                <SelectInput 
                  mdCol={3}
                  option={gradeOptions}
                  label="Grade"
                  values={formik.values.grade}
                  name="grade"
                  onChange={formik.handleChange}
                  />
              </Row>
              <Row className="py-2">
                <TextInput
                  type="number"
                  decimalStep={0.1}
                  mdCol={4}
                  label="Unweighted point"
                  values={formik.values.unweighted_point}
                  name="unweighted_point"
                  onChange={(e:any)=>{
                    formik.setFieldValue('is_weight_point', false);
                    // formik.setFieldValue('weighted_point', 0);
                    formik.handleChange(e);
                  }}
                />
                <TextInput
                  type="number"
                  decimalStep={0.1}
                  mdCol={4}
                  label="Weighted point"
                  values={formik.values.weighted_point}
                  name="weighted_point"
                  onChange={(e:any)=>{
                    formik.setFieldValue('is_weight_point', true);
                    // formik.setFieldValue('unweighted_point', 0);
                    formik.handleChange(e);
                  }}
                />
                <TextInput
                  type="number"
                  decimalStep={0.1}
                  mdCol={4}
                  label="Credits"
                  values={formik.values.credit}
                  name="credit"
                  onChange={formik.handleChange}
                />
              </Row>
            </div>
          </div>
          <div className="custom-accordion-footer d-flex justify-content-end">
              <Button className="btn-custom" 
                variant="outlined"
                style={{marginRight: "1em"}} 
                onClick={onClose}>Cancel</Button>
              <Button className="btn-custom" 
                variant="contained"
                style={{marginRight: "1em"}} 
                onClick={() => {
                  handleSave(formik.values)
                  onClose();
              }}>Save</Button>

          </div>
        </div>
      </div>
      )}
    </React.Fragment>
  );
};

export default FormCreateGpaForecastModal;